import { BaseMutations } from '@/store/base-mutations';
import { OrganizationBlackListFilters, Organizations } from '@/modules/organizations/types';
import BlackListState from './state';

export default class BlackListMutations extends BaseMutations<BlackListState> {
  SET_BLACK_LISTS(black_list: Organizations.OrganizationBlackList[]) {
    this.state.black_list = black_list;
  }

  TOGGLE_LOADING_BLACK_LISTS(toggle: boolean) {
    this.state.black_list_loading = toggle;
  }

  UPD_BLACK_LIST_FILTER_KEY({
    key,
    value,
  }: {
    key: keyof OrganizationBlackListFilters | string;
    value: unknown;
  }) {
    this.state.filters[key] = value;
  }
}
